import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {OrderProcessorSearchPageComponent} from "./order_processor/order-processor-search-page/order-processor-search-page.component";
import {PreparationResourceTypeSearchPageComponent} from "./preparation-resource-type/preparation-resource-type-search-page/preparation-resource-type-search-page.component";
import {PreparationResourceTypeEditPageComponent} from "./preparation-resource-type/preparation-resource-type-edit-page/preparation-resource-type-edit-page.component";
import {OrderAssignmentRuleSearchPageComponent} from "./order_assignment-rule/order-assignment-rule-search-page/order-assignment-rule-search-page.component";
import {OrderAssignmentRuleEditPageComponent} from "./order_assignment-rule/order-assignment-rule-edit-page/order-assignment-rule-edit-page.component";
import {DocketPrintingRuleSearchPageComponent} from "./docket-printing-rule/docket-printing-rule-search-page/docket-printing-rule-search-page.component";
import {DocketPrintingRuleEditPageComponent} from "./docket-printing-rule/docket-printing-rule-edit-page/docket-printing-rule-edit-page.component";
import {KitchenDisplaySearchPageComponent} from "./kitchen-display/kitchen-display-search-page/kitchen-display-search-page.component";
import {KitchenDisplayEditPageComponent} from "./kitchen-display/kitchen-display-edit-page/kitchen-display-edit-page.component";
import {OrderProcessingSharedModule} from "./order-processing.shared.module";
import {KvdDisplayTypeSelectOptionsComponent} from "./order_processor/controls/kvd-display-type-select-options.component";
import {KvdDocketButtonTypeSelectOptionsComponent} from "./order_processor/controls/kvd-docket-button-type-select-options.component";
import {KvdDocketTimerTypeSelectOptionsComponent} from "./order_processor/controls/kvd-docket-timer-type-select-options.component";
import {OrderActionDisplaySearchPageComponent} from "./order-action-display/order-action-display-search-page/order-action-display-search-page.component";
import {OrderActionDisplayEditPageComponent} from "./order-action-display/order-action-display-edit-page/order-action-display-edit-page.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {SystemSharedModule} from "../system/system.shared.module";
import {OrderActionEditFormComponent} from "./order-action-display/order-action-display-edit-page/order-action-edit-form/order-action-edit-form.component";
import {OrderActionTypeSelectOptionsComponent} from "./order-action-display/controls/order-action-type-select-options.component";
import {OrderReadyDisplaySearchPageComponent} from "./order-ready-display/order-ready-display-search-page/order-ready-display-search-page.component";
import {OrderReadyDisplayEditPageComponent} from "./order-ready-display/order-ready-display-edit-page/order-ready-display-edit-page.component";
import {
    DocketSelectorEditPageComponent
} from "./docket-selector/docket-selector-edit-page/docket-selector-edit-page.component";
import {
    DocketSelectorSearchPageComponent
} from "./docket-selector/docket-selector-search-page/docket-selector-search-page.component";
import {
    OrderReadyQualifierSearchPageComponent
} from "./order-ready-qualifier/order-ready-qualifier-search-page/order-ready-qualifier-search-page.component";
import {
    OrderReadyQualifierEditPageComponent
} from "./order-ready-qualifier/order-ready-qualifier-edit-page/order-ready-qualifier-edit-page.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        OrderProcessingSharedModule,
        PosSharedModule,
        CatalogueSharedModule,
        SystemSharedModule
    ],
    declarations: [
        DocketSelectorSearchPageComponent,
        DocketSelectorEditPageComponent,
        KvdDisplayTypeSelectOptionsComponent,
        KvdDocketButtonTypeSelectOptionsComponent,
        KvdDocketTimerTypeSelectOptionsComponent,
        OrderProcessorSearchPageComponent,
        DocketPrintingRuleSearchPageComponent,
        DocketPrintingRuleEditPageComponent,
        KitchenDisplaySearchPageComponent,
        KitchenDisplayEditPageComponent,
        OrderAssignmentRuleSearchPageComponent,
        OrderAssignmentRuleEditPageComponent,
        PreparationResourceTypeSearchPageComponent,
        PreparationResourceTypeEditPageComponent,
        OrderActionDisplaySearchPageComponent,
        OrderActionDisplayEditPageComponent,
        OrderActionEditFormComponent,
        OrderActionTypeSelectOptionsComponent,
        OrderReadyQualifierSearchPageComponent,
        OrderReadyQualifierEditPageComponent,
        OrderReadyDisplaySearchPageComponent,
        OrderReadyDisplayEditPageComponent
    ],
    exports: [
        DocketSelectorSearchPageComponent,
        DocketSelectorEditPageComponent,
        KvdDisplayTypeSelectOptionsComponent,
        KvdDocketButtonTypeSelectOptionsComponent,
        KvdDocketTimerTypeSelectOptionsComponent,
        OrderProcessorSearchPageComponent,
        DocketPrintingRuleSearchPageComponent,
        DocketPrintingRuleEditPageComponent,
        KitchenDisplaySearchPageComponent,
        KitchenDisplayEditPageComponent,
        OrderAssignmentRuleSearchPageComponent,
        OrderAssignmentRuleEditPageComponent,
        PreparationResourceTypeSearchPageComponent,
        PreparationResourceTypeEditPageComponent,
        OrderActionDisplaySearchPageComponent,
        OrderActionDisplayEditPageComponent,
        OrderActionEditFormComponent,
        OrderActionTypeSelectOptionsComponent,
        OrderReadyQualifierSearchPageComponent,
        OrderReadyQualifierEditPageComponent,
        OrderReadyDisplaySearchPageComponent,
        OrderReadyDisplayEditPageComponent
    ]
})
export class OrderProcessingModule {
}
